import ConsignmentStock from "../../models/ConsignmentStock"

export default {
  data() {
    return {
      visible: true,
      edition: {
        placement: "",
      },
    }
  },

  async mounted() {
    let consignmentStock = await ConsignmentStock.find(this.$route.params.id)
    if (consignmentStock) {
      this.edition.placement = consignmentStock.placement
    }
  },

  methods: {
    close() {
      this.$router.go(-1)
    },

    save() {
      this.$emit("loading")

      ConsignmentStock
        .update(this.$route.params.id, this.edition)
        .then(response => this.$emit("consignmentstockupdate", response))
        .catch(reason => this.$emit("consignmentstockupdateerror", reason))
        .then(() => this.close())
    },
  },
}
